import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { close, getExternalIdModalState, updateExternalId, } from "state/slices/external-id-modal-slice";
import sharedModalStyles from "assets/shared-stylesheets/modal.module.css";
import { getGroupState, getTextColor } from "state/slices/group-slice";
import OpenSansText from "components/custom-texts/open-sans-text";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import { useEffect, useState } from "react";
import { FAILED, LOADING } from "utils/constants";
import { X } from "react-bootstrap-icons";

const ExternalIdModal = () => {
  const show = useAppSelector(getExternalIdModalState).open;
  const dispatch = useAppDispatch();
  const group = useAppSelector(getGroupState);
  const externalIdLabel = group.settings.external_id_label;
  const [externalId, setExternalId] = useState("");
  const { updatedStatus, failMessage } = useAppSelector(
    getExternalIdModalState
  );

  const primaryColor = group.settings.primary_color;
  const textColor = useAppSelector(getTextColor);

  useEffect(() => setExternalId(""), [show]);

  return (
    <Modal show={show}>
      <Modal.Title
        style={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: primaryColor,
        }}
        className={sharedModalStyles.modalTitle}
      >
        <BlockyHeavyText style={{ color: textColor }}>
          {externalIdLabel}
        </BlockyHeavyText>
        <X
          size={40}
          style={{
            position: "absolute",
            top: "50%",
            right: "15px",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: textColor,
          }}
          onClick={() => dispatch(close())}
        />
      </Modal.Title>
      <Modal.Body
        className={sharedModalStyles.modalBody}
        style={{ borderColor: primaryColor }}
      >
        <OpenSansText style={{ marginBottom: 10, fontSize: 12 }}>
          Please enter your {externalIdLabel}
        </OpenSansText>
        <Form style={{ width: 270 }}>
          <Form.Group>
            <Form.Control
              onChange={(e) => setExternalId(e.target.value)}
              isInvalid={updatedStatus === FAILED}
            />

            <Form.Control.Feedback type="invalid">
              {failMessage}
            </Form.Control.Feedback>
          </Form.Group>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              style={{
                backgroundColor: "white",
                marginTop: 20,
                borderColor: primaryColor,
                color: "black",
              }}
              onClick={() => {
                dispatch(close());
              }}
            >
              <BlockyMediumText>Skip</BlockyMediumText>
            </Button>
            <div style={{ width: 10 }} />
            <Button
              style={{
                backgroundColor: primaryColor,
                border: "none",
                marginTop: 20,
                width: 77,
                color: "black",
              }}
              disabled={externalId === ""}
              onClick={() => {
                dispatch(updateExternalId({ groupId: group.id, externalId }));
              }}
            >
              <div>
                {updatedStatus === LOADING ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <BlockyHeavyText>Submit</BlockyHeavyText>
                )}
              </div>
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ExternalIdModal;
